import React, { useContext, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ExportIcon } from '../../svg/export.svg';
import Button from '../../../../generic-components/Button';
import Heading from '../../../../generic-components/Heading';
import { FlowContext } from '../TransactionsWrapper';
import { httpService } from '../../../../services/http.service';
import { BASE_URL } from '../../../../constants/endpoints';
import { useStore } from '../../../../store';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';
import { TransactionTabs } from '../../state/createTransactionSlice';

const ExportTableToast = () => (
  <div className='text-bw00 text-lg font-metricR items-center justify-between flex h-[60px] py-[6px] px-[16px]'>
    <div className='ml-[9px] flex flex-wrap items-center'>
      <div className='font-metricR text-sm text-bw00'>Exporting to “Lili transactions.csv“</div>
    </div>
  </div>
);

export const ExportTable = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const ctx = useContext(FlowContext);
  const queryString = useMemo(() => ctx.generateQueryString(), [ctx]);
  const { customerId } = useStore((state) => state.user);
  const { selectedTransactionTab } = useStore((state) => state);
  const { selectedSyncedCard } = useStore((state) => state);
  const { t } = useTranslation();

  const handleDownload = (url: string) => {
    setIsLoading(false);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Lili Transactions';
    a.click();
  };
  const handleTableExport = async () => {
    toast(<ExportTableToast />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000,
      bodyClassName: 'p-0 text-bw00',
      className: 'w-[370px] h-[60px] bg-bw08 p-0',
    });
    setIsLoading(true);
    const url = selectedTransactionTab === TransactionTabs.BANK_TRANSACTIONS
      ? `${BASE_URL}/api/v2/user/${customerId}/account/transactions/download?${queryString}`
      : `${BASE_URL}/api/v1/user/${customerId}/externalAccount/${selectedSyncedCard?.externalId}/transactions/download?${queryString}`;
    const { data } = await httpService.get(url, { responseType: 'blob' });
    handleDownload(URL.createObjectURL(data));
  };

  return (
    <Button
      className='hover:bg-bw02 hover:text-action03 rounded-[4px]'
      id='exportButton'
      onClick={handleTableExport}
      childElement={
        isLoading ? (
          <div className='w-[111px] h-[39px]'>
            <Spinner spinnerColor={SpinnerColor.Blue} height='1rem' width='1rem' />
          </div>
        ) : (
          <div className='flex justify-center gap-2 px-[20px] py-[9px]'>
            <ExportIcon />
            <Heading title={t('TRANSACTIONS_FACELIFT.EXPORT_TABLE')} className='font-metricR text-[14px] text-center' />
          </div>
        )
      }
    />
  );
};
